"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfWordEndingIsOnExceptionList = checkIfWordEndingIsOnExceptionList;
exports.checkIfWordIsOnVerbExceptionList = checkIfWordIsOnVerbExceptionList;
exports.checkExceptionListWithTwoStems = checkExceptionListWithTwoStems;

var _flattenSortLength = require("../morphoHelpers/flattenSortLength");
/**
 * Checks whether the word ends in one of the words in an exception list that is a simple array.
 *
 * @param {string}	    word            The word to check.
 * @param {string[]}	exceptionList	The list of exceptions.
 *
 * @returns {boolean}	Whether the checked word ends in one of the words in the exception list.
 */


function checkIfWordEndingIsOnExceptionList(word, exceptionList) {
  for (var i = 0; i < exceptionList.length; i++) {
    if (word.endsWith(exceptionList[i])) {
      return true;
    }
  }

  return false;
}
/**
 * Checks whether a word is on a verb exception list. Before checking the list, checks whether the word has a verb prefix
 * and if it does, removes it.
 *
 * @param {string}	 	word					The word to check.
 * @param {string[]}	exceptionList			The list of exceptions
 * @param {Object}		compoundVerbPrefixes	The list of separable and inseparable verb prefixes
 * @returns {boolean}	Whether the word was found on the exception list or not
 */


function checkIfWordIsOnVerbExceptionList(word, exceptionList, compoundVerbPrefixes) {
  var prefixes = (0, _flattenSortLength.flattenSortLength)(compoundVerbPrefixes); // Check whether the inputted word starts with one of the compound prefixes

  var foundPrefix = prefixes.find(function (prefix) {
    return word.startsWith(prefix);
  });
  var stemmedWordWithoutPrefix = "";

  if (typeof foundPrefix === "string") {
    stemmedWordWithoutPrefix = word.slice(foundPrefix.length); // At least 3 characters left after prefix deletion so that e.g. "be" is not treated as a prefix if found in the word "berg".

    if (stemmedWordWithoutPrefix.length > 2) {
      word = stemmedWordWithoutPrefix;
    }
  }

  return exceptionList.includes(word);
}
/**
 * Checks whether the word ends in one of the words in an exception list with two stems.
 *
 * @param {Array} exceptionListWithTwoStems The exception list with two stems
 * @param {string} word	The word to check
 * @returns {string} The stem
 */


function checkExceptionListWithTwoStems(exceptionListWithTwoStems, word) {
  var _iterator = _createForOfIteratorHelper(exceptionListWithTwoStems),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var stemSet = _step.value;
      var foundStem = stemSet.find(function (stemWord) {
        return word.endsWith(stemWord);
      });

      if (foundStem) {
        var precedingLexicalMaterial = word.slice(0, word.length - foundStem.length);
        return precedingLexicalMaterial + stemSet[0];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}